import React from 'react';
import Glide from '@glidejs/glide';
import { PauseIcon } from '../../react/eagerlyIcons/src/__generated__/icons';
import { PlayIcon } from '../../react/eagerlyIcons/src/__generated__/icons';

export default class Autoplay {
	constructor(element) {
		this.element = element;
		this.interval = element.dataset.interval;
		this.options = {
			autoplay: this.interval, // Autoplay interval from data attribute
			perView: 1,
			hoverpause: false,
			swipeThreshold: false,
			dragThreshold: false,
			animationDuration: 0,
			rewindDuration: 0,
			gap: 0,
		};

		// Initialize Glide instance
		this.glide = new Glide(this.element, this.options).mount();

		// Set up play/pause button
		this.initPlayPauseButton();
	}

	initPlayPauseButton() {
		let isPaused = false;

		// Function to handle play/pause toggle
		const togglePlayPause = () => {
			if (isPaused) {
				this.glide.play();
				this.updateButtonState(false);
			} else {
				this.glide.pause();
				this.updateButtonState(true);
			}
			isPaused = !isPaused;
		};

		// Function to update button state
		this.updateButtonState = (paused) => {
			const activeSlide = this.element.querySelector('.glide__slide--active');
			if (!activeSlide) return;

			const playPauseButton = activeSlide.querySelector('.glide__pause-btn');
			if (!playPauseButton) return;

			if (paused) {
				playPauseButton.setAttribute('aria-label', 'Video afspelen');
				playPauseButton.innerHTML = `
					<svg class="icon play-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 5v14l11-7z" fill="currentColor"/>
					</svg>
				`;
			} else {
				playPauseButton.setAttribute('aria-label', 'Video pauzeren');
				playPauseButton.innerHTML = `
					<svg class="icon pause-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="6" y="5" width="4" height="14" fill="currentColor"/>
						<rect x="14" y="5" width="4" height="14" fill="currentColor"/>
					</svg>
				`;
			}
		};

		// Add event listeners to all buttons
		const allButtons = this.element.querySelectorAll('.glide__pause-btn');
		allButtons.forEach(button => {
			// Click event
			button.addEventListener('click', togglePlayPause);

			// Keyboard events for accessibility
			button.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault(); // Prevent default space key behavior (page scroll)
					togglePlayPause();
				}
			});
		});

		// Update button state when slides change
		this.glide.on(['mount.after', 'run'], () => {
			this.updateButtonState(isPaused);
		});
	}
}
